<template>
  <app-content class="h-panel" style="overflow: hidden">
    <div style="margin: 20px 20px 0px 20px;display: flex; align-items: center; justify-content: space-between;">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
        <div v-if="params.voucherDate.start!==params.voucherDate.end">{{ fqFormat(params.voucherDate.start) }} 至 {{ fqFormat(params.voucherDate.end) }}</div>
        <div v-else>{{ fqFormat(params.voucherDate.start) }}</div>
        <template #content>
          <Form style="padding: 10px;width: 400px">
            <FormItem class="!pb-5px" label="会计期间">
              <div class="flex items-center">
                <Select @change="dateCheck" v-model="params.voucherDate.start" :deletable="false" filterable :datas="checkoutSelect"/>
                <span class="mx-8px">至</span>
                <Select @change="dateCheck" v-model="params.voucherDate.end" :deletable="false" filterable :datas="checkoutSelect"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px" label="排序方式">
              <Radio v-model="params.sorting" :datas="[{key:1,title:'降序'},{key:2,title:'升序'}]"></Radio>
            </FormItem>
            <FormItem class="!pb-5px">
              <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
              <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
              <Button @click="resetForm">重置</Button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div v-if="storageInfo" style="flex-shrink: 0; margin-left: 16px; line-height: 1.6;">
        <div>
          <span style="color: #999;">基础容量：</span>
          <span>{{ storageInfo.storageLimit }} MB</span>
          <span style="margin-left:10px;color: #999;">扩展容量：</span>
          <span @click="buyModel=true" :class="storageInfo.extraStorageValid ? 'text-green' : 'text-red'">
            {{ storageInfo.extraStorageLimit }} MB
            <span v-if="storageInfo.expirationStorageDate">
              （{{ storageInfo.expirationStorageDate }} 过期）
            </span>
            <span v-if="!storageInfo.extraStorageValid && storageInfo.extraStorageLimit > 0">【已过期】</span>
          </span>
        </div>
        <div>
          <span style="color: #999;">总已用：</span>
          <span>{{ storageInfo.totalUsed }} MB</span>
          <span style="margin-left:10px;color: #999;">总可用：</span>
          <span>{{ storageInfo.totalStorageLimit }} MB</span>
          <span style="margin-left:10px;color: #999;">当前账套用量：</span>
          <span>{{ storageInfo.accountSetsUsed }} MB</span>
        </div>
      </div>
    </div>
    <div class="h-panel-body voucher-list">
      <table class="header">
        <tr>
          <td style="width: 16%">附件名称</td>
          <td style="width: 16%">凭证号</td>
          <td style="width: 16%">日期</td>
          <td style="width: 16%">大小</td>
          <td style="width: 16%">上传人</td>
          <td style="width: 20%">操作</td>
        </tr>
      </table>
      <table v-if="!datas.length">
        <tr>
          <td colspan="5" class="text-center padding">暂无数据</td>
        </tr>
      </table>
      <div style="height: 650px; overflow-y: auto;">
        <table class="details" v-for="data in datas" :key="data.id">
          <tr>
            <td style="width: 16%">{{ data.name }}</td>
            <td style="width: 16%">
              <router-link class="text-hover primary-color" @success="loadList()" width="1120px"
                          v-if="data.id"
                          :to="{name:'VoucherForm',params:{voucherId:data.id}}">
                {{ data.word }}-{{ data.code }}
              </router-link>
            </td>
            <td style="width: 16%">{{ data.voucherDate }}</td>
            <td style="width: 16%">{{ data.size }}</td>
            <td style="width: 16%">{{ data.createMemberName }}</td>
            <td style="width: 20%">
              <a :href="'/api'+data.url+'?name='+data.name" target="_blank">查看附件</a>
            </td>
          </tr>
        </table>
      </div>
      <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
    </div>
    <Modal v-model="buyModel" v-bind="buyStyle">
      <div style="margin-bottom: 10px; font-size: 16px; font-weight: 600;">扩展附件容量</div>

      <div style="width: 540px; padding: 10px 0;">
        <div style="display: flex; flex-direction: column; gap: 12px">

          <!-- 1GB -->
          <div style="padding: 16px; border: 1px solid #E5E6EB; border-radius: 10px; display: flex; justify-content: space-between; align-items: center; background: #fff;">
            <div>
              <div style="font-size: 15px; font-weight: 600; color: #1D2129;">1GB 扩展容量</div>
              <div style="color: #86909C; font-size: 12px; margin-top: 4px">有效期 1 年</div>
            </div>
            <div style="text-align: right;">
              <div style="font-size: 14px; color: #C9CDD4; text-decoration: line-through;">原价 ¥80/年</div>
              <div style="font-size: 18px; font-weight: bold; color: #1677FF; margin-top: 2px;">¥50/年</div>
            </div>
          </div>

          <!-- 5GB -->
          <div style="padding: 16px; border: 1px solid #E5E6EB; border-radius: 10px; display: flex; justify-content: space-between; align-items: center; background: #fff;">
            <div>
              <div style="font-size: 15px; font-weight: 600; color: #1D2129;">5GB 扩展容量</div>
              <div style="color: #86909C; font-size: 12px; margin-top: 4px">有效期 1 年</div>
            </div>
            <div style="text-align: right;">
              <div style="font-size: 14px; color: #C9CDD4; text-decoration: line-through;">原价 ¥400/年</div>
              <div style="font-size: 18px; font-weight: bold; color: #1677FF; margin-top: 2px;">¥250/年</div>
            </div>
          </div>

          <!-- 10GB -->
          <div style="padding: 16px; border: 1px solid #E5E6EB; border-radius: 10px; display: flex; justify-content: space-between; align-items: center; background: #fff;">
            <div>
              <div style="font-size: 15px; font-weight: 600; color: #1D2129;">10GB 扩展容量</div>
              <div style="color: #86909C; font-size: 12px; margin-top: 4px">有效期 1 年</div>
            </div>
            <div style="text-align: right;">
              <div style="font-size: 14px; color: #C9CDD4; text-decoration: line-through;">原价 ¥800/年</div>
              <div style="font-size: 18px; font-weight: bold; color: #1677FF; margin-top: 2px;">¥500/年</div>
            </div>
          </div>

          <!-- 更多 -->
          <div style="padding: 16px; border: 1px solid #E5E6EB; border-radius: 10px; display: flex; justify-content: space-between; align-items: center; background: #fff;">
            <div>
              <div style="font-size: 15px; font-weight: 600; color: #1D2129;">更多弹性扩展容量</div>
              <div style="color: #86909C; font-size: 12px; margin-top: 4px">有效期 1 年</div>
            </div>
            <div style="text-align: right;">
              <div style="font-size: 14px; color: #C9CDD4; text-decoration: line-through;">原价 面议</div>
              <div style="font-size: 18px; font-weight: bold; color: #1677FF; margin-top: 2px;">¥议价/年</div>
            </div>
          </div>

        </div>

        <!-- 购买提示 -->
        <div style="margin-top: 20px; padding: 14px; background: #F7F8FA; border-radius: 10px; text-align: center; color: #4E5969; font-size: 14px;">
          如需购买、扩容、升级，请联系客服开通专属服务
        </div>
      </div>

      <div style="text-align: right; margin-top: 20px">
        <vxe-button @click="buyModel=false" content="关闭" />
      </div>
    </Modal>
  </app-content>
</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import {h} from 'vue'
import Common from "@/api/common";
import {clone, pick} from "xe-utils";
import {layer} from "@layui/layer-vue";
import VoucherImport from "@/views/voucher/VoucherImport";
import manba from "manba";
import voucher from "@/api/voucher";
import {downloadBlob} from "download.js";
import FinishingOffNo from "@/views/voucher/FinishingOffNo.vue";
import {message} from "heyui.ext";

const DEFAULT_VALUE = {
  closeOnMask: false,
  fullScreen: false,
  middle: true,
  hasMask: true,
  hasDivider: false,
  hasCloseIcon: true,
  draggable: false
};


export default {
  name: "BillList",
  components: {},
  data() {
    return {
      buyModel: false,
      buyStyle: {
        ...DEFAULT_VALUE
      },
      storageInfo: null,
      datas: [],
      accountDate: null,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      params: {
        voucherDate: {start: null, end: null},
        sorting:1,
        audit: 0
      },
      loading: false,
    };
  },
  watch: {
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    date() {
      return manba(this.accountDate);
    }
  },
  methods: {
    loadStorageInfo() {
      Common.getStorageInfo().then(res => {
        console.log("数据室",res,this.currentAccountSets.id)
        // 从accountSets列表中找到当前账套的用量
        let currentUsed = 0;
        if (res.data.result.accountSetsList && this.currentAccountSets) {
          const current = res.data.result.accountSetsList.find(a => a.accountSetsId === this.currentAccountSets.id);
          console.log("当前账套用量",current) 
          if (current) currentUsed = (current.attachmentSize / 1024 / 1024).toFixed(2);
        }
        this.storageInfo = {
          storageLimit: res.data.result.storageLimit,//基础容量
          extraStorageLimit: res.data.result.extraStorageLimit,//扩展容量
          expirationStorageDate: res.data.result.expirationStorageDate,//扩展容量过期时间
          totalStorageLimit: res.data.result.totalStorageLimit,//总可用
          totalUsed: (res.data.result.totalUsed / 1024 / 1024).toFixed(2),//总使用量
          accountSetsUsed: currentUsed,
          extraStorageValid: res.data.result.extraStorageValid,
        };
      });
    },
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.voucherDate.start);
      let endDate = new Date(this.params.voucherDate.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    ...mapActions(['init']),
    currentChange() {
      this.loadList();
    },
    trigger(key) {
      this[key].call(this);
    },
    processedData(data){
      let processedData = [];
      data.forEach(item => {
        if (item.billList && item.billList.length > 0) {
          item.billList.forEach(billItem => {
            // 复制原始对象的属性
            const newItem = {...item};
            // 添加 billList 的属性
            newItem.name = billItem.name;
            newItem.size  = billItem.size;
            newItem.url = billItem.url;
            // 删除 billList 属性，因为我们已经展开了数据
            delete newItem.billList;
            // 将处理后的项添加到新数组
            processedData.push(newItem);
          });
        } else {
          // 如果没有 billList，直接将原始对象添加到新数组
          // processedData.push(item);无需处理
        }
      });
      console.log(processedData)
      return processedData;
    },
    loadList() {
      this.datas = [];
      const loadId = layer.load(2);
      voucher.billList(this.pagination, this.params).then(({data}) => {
        this.datas = this.processedData(data.results) || [];
        this.pagination = {
          page: data.page,
          size: data.size,
          total: data.total
        }
        this.$refs.paramsDropdown.hide()
      }).finally(() => layer.close(loadId))
    },
  },
  created() {
    this.params.voucherDate.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.voucherDate.end = this.params.voucherDate.start;
    this.cloneParams = clone(this.params, true);
    this.loadList();
    this.loadStorageInfo();
  }
};
</script>
<style scoped>

/* jxd css样式调整 */
.h-dropdowncustom{
  margin-top: -2px;
}
.text-green {color: #00b42a;cursor: pointer; text-decoration: underline; hover: underline;}
.text-red {color: #f53f3f;cursor: pointer; text-decoration: underline; hover: underline;}

</style>
